import React, { useImperativeHandle, forwardRef, useState, useEffect } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  createStyles,
  Box,
  CircularProgress,
  Typography,
} from "@material-ui/core";

import { SECONDARY_COLOR, ATALHO_AVANCAR } from "../../../../../utils";

const useStyles = makeStyles((theme) =>
  createStyles({
    action: {
      display: "flex",
      justifyContent: "space-between",
    },
    root: {
      backgroundColor: theme.palette.background.paper,
    },
    button: {
      color: "white",
      backgroundColor: theme.palette.secondary.main,
      "&:hover": {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
    disabledButton: {
      backgroundColor: "red",
    },
  }),
);

const FECHAR_VENDA_ACTION = ATALHO_AVANCAR;

const DialogoStatusImpressao = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const [titulo, setTitulo] = useState("");
  const [corpo, setCorpo] = useState("");
  const [tempo, setTempo] = useState(0);
  const [conteudoExtra, setConteudoExtra] = useState(null);
  // onFechar != null → modo "finalizado": sem spinner, com botão Fechar
  const [onFechar, setOnFechar] = useState(null);

  const classes = useStyles();

  useImperativeHandle(ref, () => ({
    /**
     * @param {string} titulo
     * @param {string} corpo
     * @param {React.ReactNode} conteudoExtra
     * @param {Function|null} onFechar  - quando fornecido, exibe botão "Fechar" e esconde o spinner
     */
    handleOpen(titulo, corpo, conteudoExtra = null, onFechar = null) {
      setTempo(0);
      setOpen(true);
      setTitulo(titulo);
      setCorpo(corpo);
      setConteudoExtra(conteudoExtra);
      setOnFechar(() => onFechar); // wrapping em função para setState não invocar
    },
    handleFechar() {
      setOpen(false);
      setTitulo("");
      setCorpo("");
      setConteudoExtra(null);
      setOnFechar(null);
    },
  }));

  useEffect(() => {
    if (!open || onFechar) return;

    const interval = setInterval(() => {
      setTempo((t) => t + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [open, onFechar]);

  const modoFinalizado = onFechar !== null;

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth
        maxWidth="sm"
        onKeyDown={(e) => {
          if(e.key === FECHAR_VENDA_ACTION) {
            if(onFechar) {
              onFechar()
            }
          }
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            color: "white",
            backgroundColor: SECONDARY_COLOR,
            textAlign: "center",
          }}
        >
          {titulo}
        </DialogTitle>

        <DialogContent style={{ padding: "20px 10px" }}>
          {/* Modo carregamento: mostra spinner e tempo */}
          {!modoFinalizado && (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              py={4}
            >
              <CircularProgress />
              <Typography variant="subtitle1" style={{ marginTop: 16 }}>
                {corpo}
              </Typography>
              <Typography variant="subtitle2" style={{ marginTop: 20 }}>
                {tempo}s
              </Typography>
            </Box>
          )}

          {/* Conteúdo extra (pontos de fidelidade ou outro JSX) */}
          {conteudoExtra}
        </DialogContent>

        {/* Botão Fechar — aparece apenas no modo finalizado */}
        {modoFinalizado && (
          <DialogActions style={{ justifyContent: "center", paddingBottom: 16 }}>
            <Button
              variant="contained"
              className={classes.button}
              onClick={onFechar}
              size="large"
              style={{ minWidth: 160 }}
              autoFocus
            >
              Fechar (F8)
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
});

export default DialogoStatusImpressao;
